/**
 * @description Define the fake link controller.
 */
export default class FakeLinkController {
    constructor(domElement) {
        if(!domElement) {
            throw new DOMException('element is undefined');
        }

        if(domElement.fakeLink) {
            return;
        }

        domElement.fakeLink = this;

        this.domElement = domElement;

        domElement.addEventListener('click', this.handleLinkClick.bind(this));
    }

    handleLinkClick() {
        const {href, target} = this.domElement.dataset;

        if(href) {
            if(target) {
                window.open(href, target);
            } else {
                window.location.href = href;
            }
        }
    }
}
